export default __webpack_public_path__ + "static/media/facebook-footer.fd0ef14c.svg";